import { FormGroup, UntypedFormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

export const mockFormlyField = (component: FieldType) => {
  component.field = {
    type: 'object',
    options: { showError: () => false },
    props: { fields: [], dropdown: {} },
    fieldArray: { fieldGroup: [] },
    form: new FormGroup<any>({}),
    formControl: new UntypedFormControl(),
    validators: { validation: [] },
  };
};
